// extracted by mini-css-extract-plugin
export default {"wrapper":"AuthPage_wrapper__l2Rly","copyright":"AuthPage_copyright__MOv5R","auth":"AuthPage_auth__heLtG","background":"AuthPage_background__9QtoP"};